import { useLocation } from 'react-router-dom';
import {
  deleteGameCard,
  fetchCardGame,
  fetchCardsGame,
  selectGameState,
} from '../../store/gamesSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

const useGames = () => {
  const dispatch = useAppDispatch();
  const { gameCards, gameCard, loading } = useAppSelector(selectGameState);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const action = queryParams.get('action');

  const onGetGamesCard = async () => {
    await dispatch(fetchCardsGame({}));
  };

  const onGetOneGameCard = async () => {
    await dispatch(fetchCardGame(queryParams.get('id') as string));
  };

  const onDeleteGameCard = async (id: string) => {
    await deleteGameCard(id);
  };

  return {
    onGetGamesCard,
    gameCards,
    onDeleteGameCard,
    onGetOneGameCard,
    gameCard,
    loading,
    action,
  };
};

export default useGames;
